import { systemClock, uuidGenerator } from '@miyuki/domain';
import * as React from 'react';

import { DesignerScreen } from './components/designer-screen';
import { createLocalStoragePatternRepository } from './lib/local-storage-pattern.repository';

/**
 * Una sola pantalla: el lienzo. Los ajustes son paneles, no rutas, así que la
 * aplicación no necesita enrutador (RF-47, RF-49).
 *
 * Tema claro único: nunca se aplica la clase `dark` ni se ofrece un selector
 * (RF-48).
 */
export function App() {
  const repository = React.useMemo(
    () =>
      createLocalStoragePatternRepository({
        storage: window.localStorage,
        clock: systemClock,
        ids: uuidGenerator,
      }),
    [],
  );

  return <DesignerScreen repository={repository} />;
}
